module.exports = __webpack_public_path__ + "img/Flag_of_the_Cook_Islands.9c18aba7.svg";